<template>
	<!-- https://github.com/wearebraid/vue-formulate/issues/434 -->
	<form style="min-height: 0; padding:0; margin: 0; display: inline-block;">
		<FormulateInput
			:id="context.id"
			v-model="context.model"
			type="radio"
			class="radio-inline"
			:name="context.name"
			:options="context.options"
			:class="context.classes"
			:help="context.help"
			:validation="context.validation"
			:validation-name="context.validationName"
			:validation-messages="context.validationMessages" />
	</form>
</template>
<script>

export default {
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			//
		}
	}
}
</script>
